import React, { useEffect, useState } from "react";

import { useMarket } from "../../hooks/useMarket";
import { useCore } from "../../hooks/useCore";
import { useCollection } from "../../hooks/useCollection";
import { useNavigator } from "../../hooks/useNavigator";


import toast from 'react-simple-toasts';
import { CopyToClipboard } from "react-copy-to-clipboard";
import ReactTooltip from 'react-tooltip';

import classNames from "classnames";

import { getPosition } from "../../utils/tools";

var FileSaver = require('file-saver');

export function AssetToolbar({ nft, ca, addClass, collection=null }) {

    const navigator = useNavigator();
    let { contractAddress, handleContractAddress, screens } = useNavigator();


    const { fullscreen, toggleFullscreen, modalVisible, handleModalVisible, qrModal, handleQrModal, handleQrurl, handleModalTitle, handleCollectionModal } = useCore();
    const { assetToAdd, handleAssetToAdd, collections, handleShowCollectionsOptions, showCollectionsOptions } = useCollection();
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        ReactTooltip.rebuild();
    }, [] );


    const handleClick = () => {
        // passClick(nftp.address);
    }

    const open3d = () => {
        navigator.push(`/experiments/${collection.token}`);
    }


    const openOpenSea = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.open(
            `https://opensea.io/assets/ethereum/${ca}/${nft.token_id}`,
            'opensea'
            // 'toolbar=0,status=0,width=548,height=325'
        );
    }

    const openEtherscan = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.open(
            `https://etherscan.io/token/${ca}?a=${nft.token_id}#inventory`,
            'etherscan'
            // 'toolbar=0,status=0,width=548,height=325'
        );
    }

    const showQRModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleModalTitle(nft.name + ' - #' + nft.token_id);
        let qu = `${process.env.REACT_APP_ARTEMIS_URL_IP}/assets/${ca}/${nft.token_id}`;
        console.log(qu);
        handleQrurl(qu);
        handleModalVisible(true);
        handleQrModal(true);
    }

    const openQRUrl = (e) => {
        e.preventDefault();
        e.stopPropagation();


        let qu = `${process.env.REACT_APP_ARTEMIS_URL_IP}/assets/${nft.token_address}/${nft.token_id}`;
        window.open(
            qu,
            'qru'
            // 'toolbar=0,status=0,width=548,height=325'
        );
    }

    function copy() {
        setCopied(true);
        toast('URL copied');

        setTimeout(function () {
            setCopied(false);
        }, 3000);
    }


    function downloadImage(){
        console.log('download')
        let img = nft.metadata?.image ? nft.metadata.image : nft.image_url;
        let i = img !== undefined ? img.replace("ipfs://","https://ipfs.io/ipfs/") : '';

        FileSaver.saveAs(i, `${nft.name}.jpg`);
    }

    function showAddCollection(e){
        // e.stopImmediatePropagation();
        // console.log("event.target:", e.target.id);
        // console.log("event.currentTarget", e.currentTarget);
        if(collections.length < 1){
            handleCollectionModal(true);
            handleModalVisible(true);
        }else{
            if(showCollectionsOptions){
                // handleShowCollectionsOptions(false, "off","off");
            }else{
                handleAssetToAdd(nft);

                let ex = e.clientX;
                let ey = e.clientY + 33;
                handleShowCollectionsOptions(!showCollectionsOptions, ex, ey );

            }
        }


    }



    return (



        <div className="coin-links">

            <div onClick={openEtherscan} data-tip="view on etherscan" className="coin-link">
                <div className="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="293.775" height="293.667" viewBox="0 0 293.775 293.667">
                      <g id="etherscan-logo-light-circle" transform="translate(-219.378 -213.333)">
                        <path id="Path_1" data-name="Path 1" d="M280.433,353.152A12.45,12.45,0,0,1,292.941,340.7l20.737.068a12.467,12.467,0,0,1,12.467,12.467v78.414c2.336-.692,5.332-1.43,8.614-2.2a10.389,10.389,0,0,0,8.009-10.11V322.073a12.469,12.469,0,0,1,12.467-12.47h20.779a12.47,12.47,0,0,1,12.467,12.47v90.276s5.2-2.106,10.269-4.245a10.408,10.408,0,0,0,6.353-9.577V290.9a12.466,12.466,0,0,1,12.465-12.467h20.779A12.468,12.468,0,0,1,450.815,290.9v88.625c18.014-13.055,36.271-28.758,50.759-47.639a20.926,20.926,0,0,0,3.185-19.537,146.6,146.6,0,0,0-136.644-99.006c-81.439-1.094-148.744,65.385-148.736,146.834a146.371,146.371,0,0,0,19.5,73.45,18.56,18.56,0,0,0,17.707,9.173c3.931-.346,8.825-.835,14.643-1.518a10.383,10.383,0,0,0,9.209-10.306V353.152" transform="translate(0 0)" />
                        <path id="Path_2" data-name="Path 2" d="M244.417,398.641A146.808,146.808,0,0,0,477.589,279.9c0-3.381-.157-6.724-.383-10.049-53.642,80-152.686,117.405-232.79,128.793" transform="translate(35.564 80.269)" fill="#bfcfda"/>
                      </g>
                    </svg>

                </div>
            </div>
            <div onClick={openOpenSea} data-tip="view on opensea" className="coin-link">
                <div className="svg-icon">
                    <svg width="90" height="90" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg">
                    <path d="M45 0C20.151 0 0 20.151 0 45C0 69.849 20.151 90 45 90C69.849 90 90 69.849 90 45C90 20.151 69.858 0 45 0ZM22.203 46.512L22.392 46.206L34.101 27.891C34.272 27.63 34.677 27.657 34.803 27.945C36.756 32.328 38.448 37.782 37.656 41.175C37.323 42.57 36.396 44.46 35.352 46.206C35.217 46.458 35.073 46.71 34.911 46.953C34.839 47.061 34.713 47.124 34.578 47.124H22.545C22.221 47.124 22.032 46.773 22.203 46.512ZM74.376 52.812C74.376 52.983 74.277 53.127 74.133 53.19C73.224 53.577 70.119 55.008 68.832 56.799C65.538 61.38 63.027 67.932 57.402 67.932H33.948C25.632 67.932 18.9 61.173 18.9 52.83V52.56C18.9 52.344 19.08 52.164 19.305 52.164H32.373C32.634 52.164 32.823 52.398 32.805 52.659C32.706 53.505 32.868 54.378 33.273 55.17C34.047 56.745 35.658 57.726 37.395 57.726H43.866V52.677H37.467C37.143 52.677 36.945 52.299 37.134 52.029C37.206 51.921 37.278 51.813 37.368 51.687C37.971 50.823 38.835 49.491 39.699 47.97C40.284 46.944 40.851 45.846 41.31 44.748C41.4 44.55 41.472 44.343 41.553 44.145C41.679 43.794 41.805 43.461 41.895 43.137C41.985 42.858 42.066 42.57 42.138 42.3C42.354 41.364 42.444 40.374 42.444 39.348C42.444 38.943 42.426 38.52 42.39 38.124C42.372 37.683 42.318 37.242 42.264 36.801C42.228 36.414 42.156 36.027 42.084 35.631C41.985 35.046 41.859 34.461 41.715 33.876L41.661 33.651C41.553 33.246 41.454 32.868 41.328 32.463C40.959 31.203 40.545 29.97 40.095 28.818C39.933 28.359 39.753 27.918 39.564 27.486C39.294 26.82 39.015 26.217 38.763 25.65C38.628 25.389 38.52 25.155 38.412 24.912C38.286 24.642 38.16 24.372 38.025 24.111C37.935 23.913 37.827 23.724 37.755 23.544L36.963 22.086C36.855 21.888 37.035 21.645 37.251 21.708L42.201 23.049H42.219C42.228 23.049 42.228 23.049 42.237 23.049L42.885 23.238L43.605 23.436L43.866 23.508V20.574C43.866 19.152 45 18 46.413 18C47.115 18 47.754 18.288 48.204 18.756C48.663 19.224 48.951 19.863 48.951 20.574V24.939L49.482 25.083C49.518 25.101 49.563 25.119 49.599 25.146C49.725 25.236 49.914 25.38 50.148 25.56C50.337 25.704 50.535 25.884 50.769 26.073C51.246 26.46 51.822 26.955 52.443 27.522C52.605 27.666 52.767 27.81 52.92 27.963C53.721 28.71 54.621 29.583 55.485 30.555C55.728 30.834 55.962 31.104 56.205 31.401C56.439 31.698 56.7 31.986 56.916 32.274C57.213 32.661 57.519 33.066 57.798 33.489C57.924 33.687 58.077 33.894 58.194 34.092C58.554 34.623 58.86 35.172 59.157 35.721C59.283 35.973 59.409 36.252 59.517 36.522C59.85 37.26 60.111 38.007 60.273 38.763C60.327 38.925 60.363 39.096 60.381 39.258V39.294C60.435 39.51 60.453 39.744 60.471 39.987C60.543 40.752 60.507 41.526 60.345 42.3C60.273 42.624 60.183 42.93 60.075 43.263C59.958 43.578 59.85 43.902 59.706 44.217C59.427 44.856 59.103 45.504 58.716 46.098C58.59 46.323 58.437 46.557 58.293 46.782C58.131 47.016 57.96 47.241 57.816 47.457C57.609 47.736 57.393 48.024 57.168 48.285C56.97 48.555 56.772 48.825 56.547 49.068C56.241 49.437 55.944 49.779 55.629 50.112C55.449 50.328 55.251 50.553 55.044 50.751C54.846 50.976 54.639 51.174 54.459 51.354C54.144 51.669 53.892 51.903 53.676 52.11L53.163 52.569C53.091 52.641 52.992 52.677 52.893 52.677H48.951V57.726H53.91C55.017 57.726 56.07 57.339 56.925 56.61C57.213 56.358 58.482 55.26 59.985 53.604C60.039 53.541 60.102 53.505 60.174 53.487L73.863 49.527C74.124 49.455 74.376 49.644 74.376 49.914V52.812V52.812Z"/>
                    </svg>

                </div>
            </div>

            <div onClick={showQRModal} data-tip="QR code" className="coin-link">
                <div className="svg-icon">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
                    <g><path d="M377.1,377.1H10V10h367.1V377.1z M78.6,308.5h229.8V78.6H78.6V308.5L78.6,308.5z"/><path d="M132.4,132.4h122.4v122.4H132.4V132.4z"/><path d="M377.1,990H10V621.8h367.1V990z M78.6,921.4h229.8v-231H78.6V921.4L78.6,921.4z"/><path d="M132.4,745.3h122.4v121.2H132.4V745.3z"/><path d="M990,377.1H621.8V10H990V377.1z M690.4,308.5h231V78.6h-231V308.5z"/><path d="M745.3,132.4h121.2v122.4H745.3V132.4z"/><path d="M10,377.1h122.4v123.5H10V377.1z"/><path d="M254.7,500.6h122.4v121.2H254.7V500.6L254.7,500.6z"/><path d="M500.6,10h121.2v122.4H500.6V10z"/><path d="M377.1,254.7h123.5v122.4H377.1V254.7z"/><path d="M500.6,866.5h121.2V990H500.6V866.5z"/><path d="M745.3,866.5H990V990H745.3V866.5z"/><path d="M500.6,621.8h244.7v123.5H500.6V621.8z"/><path d="M745.3,621.8h121.2v244.7H745.3V621.8z"/><path d="M855.1,621.8H990v123.5H855.1V621.8z"/><path d="M500.6,377.1h121.2v123.5H500.6V377.1z"/><path d="M621.8,500.6h123.5v121.2H621.8V500.6L621.8,500.6z"/><path d="M745.3,377.1h121.2v123.5H745.3V377.1z"/><path d="M866.5,500.6H990v121.2H866.5V500.6L866.5,500.6z"/></g>
                    </svg>

                </div>
            </div>


            <div onClick={downloadImage} data-tip="download" className="coin-link">
                <div className="icon-button-download"/>

            </div>

            <div onClick={showAddCollection} data-tip="add to collection" className={classNames("coin-link", showCollectionsOptions && "null")}>
                <div id="showAddCollection" className="icon-button-plus"/>

            </div>

            {/*<div onClick={null} data-tip="copy data URL" className="coin-link">
                <div className="icon-button-rss"/>

            </div>*/}

            <div onClick={null} data-tip="remove from collection" className="coin-link">
                <div className="icon-button-trash"/>

            </div>


            <div onClick={null} data-tip="copy data URL" className="coin-link">
                <div className="svg-icon">
                    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <path d="M213.333333 128h85.333334v85.333333H213.333333v213.333334a85.333333 85.333333 0 0 1-85.333333 85.333333 85.333333 85.333333 0 0 1 85.333333 85.333333v213.333334h85.333334v85.333333H213.333333c-45.653333-11.52-85.333333-38.4-85.333333-85.333333v-170.666667a85.333333 85.333333 0 0 0-85.333333-85.333333H0v-85.333334h42.666667a85.333333 85.333333 0 0 0 85.333333-85.333333V213.333333a85.333333 85.333333 0 0 1 85.333333-85.333333m597.333334 0a85.333333 85.333333 0 0 1 85.333333 85.333333v170.666667a85.333333 85.333333 0 0 0 85.333333 85.333333h42.666667v85.333334h-42.666667a85.333333 85.333333 0 0 0-85.333333 85.333333v170.666667a85.333333 85.333333 0 0 1-85.333333 85.333333h-85.333334v-85.333333h85.333334v-213.333334a85.333333 85.333333 0 0 1 85.333333-85.333333 85.333333 85.333333 0 0 1-85.333333-85.333333V213.333333h-85.333334V128h85.333334m-298.666667 512a42.666667 42.666667 0 0 1 42.666667 42.666667 42.666667 42.666667 0 0 1-42.666667 42.666666 42.666667 42.666667 0 0 1-42.666667-42.666666 42.666667 42.666667 0 0 1 42.666667-42.666667m-170.666667 0a42.666667 42.666667 0 0 1 42.666667 42.666667 42.666667 42.666667 0 0 1-42.666667 42.666666 42.666667 42.666667 0 0 1-42.666666-42.666666 42.666667 42.666667 0 0 1 42.666666-42.666667m341.333334 0a42.666667 42.666667 0 0 1 42.666666 42.666667 42.666667 42.666667 0 0 1-42.666666 42.666666 42.666667 42.666667 0 0 1-42.666667-42.666666 42.666667 42.666667 0 0 1 42.666667-42.666667z" fill="" />
                    </svg>
                </div>

            </div>







            <div onClick={null} data-tip="send asset"className="coin-link">
                <div className="icon-button-send"/>

            </div>

            <CopyToClipboard
                        text={window.location.href}
                        onCopy={copy}
            >
                <div onClick={null} data-tip="copy URL" className="coin-link">
                    <div className="icon-button-copy"/>

                </div>
            </CopyToClipboard>

            

            <div onClick={open3d} data-tip="view in 3d" className="coin-link">
                <div className="svg-icon">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 457.478 457.478">
                        <g>
                            <path d="m423.173,110.709l-189.434-109.369c-3.094-1.786-6.906-1.786-10-3.33067e-15l-189.433,109.369c-3.094,1.786-5,5.087-5,8.66v218.739c0,3.573 1.906,6.874 5,8.66l189.434,109.37c1.547,0.893 3.273,1.34 5,1.34s3.453-0.447 5-1.34l189.434-109.37c3.094-1.786 5-5.087 5-8.66v-218.739c-0.001-3.572-1.908-6.874-5.001-8.66zm-15,206.884l-6.459-3.729c-4.781-2.762-10.898-1.123-13.66,3.66-2.762,4.783-1.123,10.899 3.66,13.661l9.226,5.327-162.201,93.647v-188.638c0.128,0.005 0.255,0.024 0.383,0.024 3.456,0 6.817-1.793 8.67-5.001 1.421-2.46 1.669-5.271 0.932-7.799l159.449-92.058v180.906zm-338.747-.069c-2.761-4.782-8.874-6.422-13.66-3.66l-6.46,3.729v-180.905l159.449,92.058c-0.737,2.527-0.488,5.338 0.932,7.798 1.853,3.208 5.213,5.001 8.67,5.001 0.127,0 0.255-0.02 0.383-0.024v188.637l-162.202-93.647 9.227-5.327c4.784-2.761 6.422-8.877 3.661-13.66zm159.314-275.941c5.522,2.84217e-14 10-4.477 10-10v-4.263l159.431,92.048-159.634,92.165c-0.931-4.559-4.964-7.989-9.797-7.989-4.834,0-8.867,3.43-9.798,7.99l-159.635-92.166 159.433-92.048v4.264c0,5.522 4.478,9.999 10,9.999z"/>
                            <path d="m304.003,280.544l17.839,10.3c1.575,0.909 3.294,1.341 4.99,1.341 3.456,0 6.817-1.793 8.67-5.001 2.762-4.783 1.123-10.898-3.66-13.66l-17.839-10.3c-4.784-2.761-10.898-1.123-13.66,3.66s-1.123,10.898 3.66,13.66z"/>
                            <path d="m260.147,255.224l17.84,10.299c1.575,0.91 3.294,1.341 4.99,1.341 3.456,0 6.818-1.793 8.67-5.001 2.762-4.783 1.123-10.899-3.66-13.66l-17.84-10.299c-4.784-2.763-10.899-1.123-13.66,3.66-2.762,4.783-1.123,10.899 3.66,13.66z"/>
                            <path d="m347.857,305.864l17.84,10.3c1.575,0.909 3.294,1.341 4.99,1.341 3.456,0 6.818-1.793 8.67-5.001 2.762-4.783 1.123-10.899-3.66-13.66l-17.84-10.3c-4.784-2.762-10.9-1.123-13.66,3.66-2.762,4.783-1.123,10.899 3.66,13.66z"/>
                            <path d="m174.501,266.865c1.696,0 3.416-0.432 4.99-1.341l17.84-10.3c4.783-2.761 6.422-8.877 3.66-13.66-2.761-4.783-8.877-6.421-13.66-3.66l-17.84,10.3c-4.783,2.761-6.422,8.877-3.66,13.66 1.852,3.209 5.213,5.001 8.67,5.001z"/>
                            <path d="m86.791,317.505c1.696,0 3.415-0.432 4.99-1.341l17.84-10.299c4.783-2.761 6.422-8.877 3.66-13.66-2.76-4.782-8.874-6.421-13.66-3.66l-17.84,10.299c-4.783,2.761-6.422,8.877-3.66,13.66 1.852,3.208 5.213,5.001 8.67,5.001z"/>
                            <path d="m130.646,292.185c1.696,0 3.416-0.432 4.99-1.341l17.839-10.3c4.783-2.762 6.422-8.877 3.66-13.66-2.761-4.783-8.877-6.421-13.66-3.66l-17.839,10.3c-4.783,2.762-6.422,8.877-3.66,13.66 1.853,3.208 5.213,5.001 8.67,5.001z"/>
                            <path d="M218.74,82.223c0,5.523,4.478,10,10,10s10-4.477,10-10V61.624c0-5.523-4.478-10-10-10s-10,4.477-10,10V82.223z"/>
                            <path d="m228.74,102.264c-5.522,0-10,4.477-10,10v20.599c0,5.523 4.478,10 10,10s10-4.477 10-10v-20.599c0-5.523-4.477-10-10-10z"/>
                            <path d="m228.74,152.904c-5.522,0-10,4.477-10,10v20.599c0,5.523 4.478,10 10,10s10-4.477 10-10v-20.599c0-5.523-4.477-10-10-10z"/>
                        </g>
                    </svg>
                </div>
            </div>





            <div onClick={toggleFullscreen} data-tip="toggle fullscreen" className="coin-link">

                { fullscreen ? (
                    <div className="svg-icon">
                        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <g id="Icons-/-reduce" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <path d="M21,15.5 C21.2761424,15.5 21.5,15.7238576 21.5,16 C21.5,16.2454599 21.3231248,16.4496084 21.0898756,16.4919443 L21,16.5 L18,16.5 C17.2203039,16.5 16.5795513,17.0948881 16.5068666,17.85554 L16.5,18 L16.5,21 C16.5,21.2761424 16.2761424,21.5 16,21.5 C15.7545401,21.5 15.5503916,21.3231248 15.5080557,21.0898756 L15.5,21 L15.5,18 C15.5,16.6745166 16.5315359,15.5899613 17.8356243,15.5053177 L18,15.5 L21,15.5 Z M6,15.5 C7.3254834,15.5 8.41003867,16.5315359 8.49468232,17.8356243 L8.5,18 L8.5,21 C8.5,21.2761424 8.27614237,21.5 8,21.5 C7.75454011,21.5 7.55039163,21.3231248 7.50805567,21.0898756 L7.5,21 L7.5,18 C7.5,17.2203039 6.90511192,16.5795513 6.14446001,16.5068666 L6,16.5 L3,16.5 C2.72385763,16.5 2.5,16.2761424 2.5,16 C2.5,15.7545401 2.67687516,15.5503916 2.91012437,15.5080557 L3,15.5 L6,15.5 Z M8,2.5 C8.24545989,2.5 8.44960837,2.67687516 8.49194433,2.91012437 L8.5,3 L8.5,6 C8.5,7.3254834 7.46846406,8.41003867 6.16437569,8.49468232 L6,8.5 L3,8.5 C2.72385763,8.5 2.5,8.27614237 2.5,8 C2.5,7.75454011 2.67687516,7.55039163 2.91012437,7.50805567 L3,7.5 L6,7.5 C6.77969612,7.5 7.42044868,6.90511192 7.49313342,6.14446001 L7.5,6 L7.5,3 C7.5,2.72385763 7.72385763,2.5 8,2.5 Z M16,2.5 C16.2454599,2.5 16.4496084,2.67687516 16.4919443,2.91012437 L16.5,3 L16.5,6 C16.5,6.77969612 17.0948881,7.42044868 17.85554,7.49313342 L18,7.5 L21,7.5 C21.2761424,7.5 21.5,7.72385763 21.5,8 C21.5,8.24545989 21.3231248,8.44960837 21.0898756,8.49194433 L21,8.5 L18,8.5 C16.6745166,8.5 15.5899613,7.46846406 15.5053177,6.16437569 L15.5,6 L15.5,3 C15.5,2.72385763 15.7238576,2.5 16,2.5 Z" id="Combined-Shape" fill="#163449" fill-rule="nonzero"></path>
                            </g>
                        </svg>

                    </div>
                ):(

                    <div className="svg-icon">
                        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <g id="Icons-/-enlarge" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <path d="M21,15.5 C21.2454599,15.5 21.4496084,15.6768752 21.4919443,15.9101244 L21.5,16 L21.5,19 C21.5,20.3254834 20.4684641,21.4100387 19.1643757,21.4946823 L19,21.5 L16,21.5 C15.7238576,21.5 15.5,21.2761424 15.5,21 C15.5,20.7545401 15.6768752,20.5503916 15.9101244,20.5080557 L16,20.5 L19,20.5 C19.7796961,20.5 20.4204487,19.9051119 20.4931334,19.14446 L20.5,19 L20.5,16 C20.5,15.7238576 20.7238576,15.5 21,15.5 Z M3,15.5 C3.24545989,15.5 3.44960837,15.6768752 3.49194433,15.9101244 L3.5,16 L3.5,19 C3.5,19.7796961 4.09488808,20.4204487 4.85553999,20.4931334 L5,20.5 L8,20.5 C8.27614237,20.5 8.5,20.7238576 8.5,21 C8.5,21.2454599 8.32312484,21.4496084 8.08987563,21.4919443 L8,21.5 L5,21.5 C3.6745166,21.5 2.58996133,20.4684641 2.50531768,19.1643757 L2.5,19 L2.5,16 C2.5,15.7238576 2.72385763,15.5 3,15.5 Z M8,2.5 C8.27614237,2.5 8.5,2.72385763 8.5,3 C8.5,3.24545989 8.32312484,3.44960837 8.08987563,3.49194433 L8,3.5 L5,3.5 C4.22030388,3.5 3.57955132,4.09488808 3.50686658,4.85553999 L3.5,5 L3.5,8 C3.5,8.27614237 3.27614237,8.5 3,8.5 C2.75454011,8.5 2.55039163,8.32312484 2.50805567,8.08987563 L2.5,8 L2.5,5 C2.5,3.6745166 3.53153594,2.58996133 4.83562431,2.50531768 L5,2.5 L8,2.5 Z M19,2.5 C20.3254834,2.5 21.4100387,3.53153594 21.4946823,4.83562431 L21.5,5 L21.5,8 C21.5,8.27614237 21.2761424,8.5 21,8.5 C20.7545401,8.5 20.5503916,8.32312484 20.5080557,8.08987563 L20.5,8 L20.5,5 C20.5,4.22030388 19.9051119,3.57955132 19.14446,3.50686658 L19,3.5 L16,3.5 C15.7238576,3.5 15.5,3.27614237 15.5,3 C15.5,2.75454011 15.6768752,2.55039163 15.9101244,2.50805567 L16,2.5 L19,2.5 Z" id="icon" fill="#163449" fill-rule="nonzero"></path>
                            </g>
                        </svg>

                    </div>

                )}

            </div>







        </div>
    )
}
